import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import { mapToObjectDDL } from "../../../common/mapper";
import Api from "../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import M from "moment";

class ReceivingPartNOSFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: {},
      dataLocator: [],
      dataVariant: [],
      dataWarna: [],
    };
  }

  componentDidMount = async () => {
    this.handleTriggerLoading();
    await this.fetchDataLocator();
    await this.fetchDataVariant();
    await this.fetchDataWarna();
    this.handleTriggerLoading();
  };

  handleSubmitForm = () => {
    this.props.onSubmit(this.state.data);
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchDataLocator = async () => {
    try {
      let res = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: this.props.selectedCabang?.value },
        page: null,
        limit: null,
      });

      if (res.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataLocator: res.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataVariant = async () => {
    try {
      let response = await Api.create("NAGAMAS_MASTER_DATA").getAllVariant();
      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataVariant: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataWarna = async () => {
    try {
      let response = await Api.create("NAGAMAS_MASTER_DATA").getAllWarna();
      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataWarna: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  render() {
    return (
      <SimpleModal
        title="Filter Search"
        visible={this.props.visible}
        onClickClose={() => this.props.onClickClose()}
        content={
          <ModalContainer>
            <FlexView column>
              <FlexView column vAlignContent="center">
                <div className="txt-site txt-11 txt-main txt-bold">
                  <h4>Tanggal SL:</h4>
                </div>
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <SimpleDate
                    date={this.props.selectedData.startDate}
                    // nextdate
                    // maxDate={this.props.selectedData.endDate}
                    onChange={(value) =>
                      this.props.onValueChange(
                        "startDate",
                        M(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                  <span className="margin-bottom-20px">To</span>
                  <SimpleDate
                    date={this.props.selectedData.endDate}
                    backdate
                    minDate={this.props.selectedData.startDate}
                    onChange={(value) =>
                      this.props.onValueChange(
                        "endDate",
                        M(value).format("DD-MM-YYYY")
                      )
                    }
                  />
                </FlexView>
              </FlexView>
              <SimpleInput
                id="input_text_no_shipping_list"
                name="shippingNo"
                label="No. Shipping List (SL)"
                value={this.props.selectedData.shippingNo}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value?.trim())
                }
              />
              <SimpleInput
                id="input_text_no_invoice"
                name="receivedNo"
                label="No. Penerimnaan"
                value={this.props.selectedData.receivedNo}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value?.trim())
                }
              />
              <h3>Filter Detail</h3>
              <SimpleInput
                id="input_text_kode_part"
                name="partCode"
                label="Kode Part"
                value={this.props.selectedData.partCode}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value?.trim())
                }
              />
              <SimpleInput
                id="input_text_nama_part"
                name="partName"
                label="Nama Part"
                value={this.props.selectedData.partName}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value?.trim())
                }
              />
              <SimpleInput
                id="input_text_category"
                name="category"
                label="Kategori"
                value={this.props.selectedData.category}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value?.trim())
                }
              />
              <SimpleInput
                id="input_text_no_po"
                name="purchaseOrderNo"
                label="No. PO"
                value={this.props.selectedData.purchaseOrderNo}
                onChange={({ target }) =>
                  this.props.onValueChange(target.name, target.value?.trim())
                }
              />
            </FlexView>
            <FlexView hAlignContent="right" style={{ gap: "10px" }}>
              <SimpleButton
                secondary
                type="button"
                text={"Clear"}
                onClick={this.props.onClearForm}
              />
              <SimpleButton onClick={this.handleSubmitForm} text={"Terapkan"} />
            </FlexView>

            <SimpleLoadingOverlay active={this.state.loading} />
          </ModalContainer>
        }
      />
    );
  }
}

export default ReceivingPartNOSFilter;
